import React from 'react';

export default function Tag({ item, style }) {
  return (
    <li
      className="tag mt-05 mr-1"
      style={style}
    >
      {item.name}
    </li>
  );

}



// WEBPACK FOOTER //
// ./src/components/Tag/index.js